import { ChainSubstructureStyle, CycleSubstructureStyle, OrganicLayout, OrganicLayoutClusteringPolicy, OrganicLayoutData, OrganicLayoutGroupSubstructureScope, OrganicLayoutScope, OrganicLayoutStarSubstructureStyle, OrganicLayoutTreeSubstructureStyle, OutputRestriction, ParallelSubstructureStyle } from "yfiles";
import LayoutConfiguration from "./layoutConfiguration";
class OrganicLayoutConfig extends LayoutConfiguration {
    createConfiguredLayout() {
        const layout = new OrganicLayout({
            subgraphLayoutEnabled: false,
            minimumNodeDistance: 10,
            preferredEdgeLength: 60,
            compactnessFactor: 0.9,
            scope: OrganicLayoutScope.ALL,
            considerNodeSizes: true,
            considerNodeLabels: false,
            clusterNodes: true,
            clusteringPolicy: OrganicLayoutClusteringPolicy.NONE,
            nodeOverlapsAllowed: false,
            nodeEdgeOverlapAvoided: true,
            deterministic: true,
            create3DLayout: false,
            automaticGroupNodeCompaction: true,
            labelingEnabled: false,
            parallelEdgeRouterEnabled: false,
            componentLayoutEnabled: true,
            smartComponentLayout: false,
            clusterAsGroupSubstructureAllowed: false,
            hideGroupsStageEnabled: false,
            outputRestriction: OutputRestriction.NONE,
            cycleSubstructureStyle: CycleSubstructureStyle.CIRCULAR,
            chainSubstructureStyle: ChainSubstructureStyle.DISK,
            starSubstructureStyle: OrganicLayoutStarSubstructureStyle.CIRCULAR,
            treeSubstructureStyle: OrganicLayoutTreeSubstructureStyle.NONE,
            groupSubstructureScope: OrganicLayoutGroupSubstructureScope.NO_GROUPS,
            parallelSubstructureStyle: ParallelSubstructureStyle.RADIAL,
            parallelSubstructureTypeSeparation: true,
            starSubstructureTypeSeparation: true
        });
        return layout;
    }
    createConfiguredLayoutData(_, layout, affectedNodes) {
        if (affectedNodes) {
            layout.scope = OrganicLayoutScope.SUBSET;
        }
        return new OrganicLayoutData({
            affectedNodes: affectedNodes ? Array.from(affectedNodes) : undefined
        });
    }
}
export default OrganicLayoutConfig;
